import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycTheCommonChallengesFacedDuringTheProbateProcessPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-the-common-challenges-faced-during-the-probate-process/']} />;
}
